import { render, staticRenderFns } from "./EmailTypologyEdit.vue?vue&type=template&id=56223a16&"
import script from "./EmailTypologyEdit.vue?vue&type=script&lang=js&"
export * from "./EmailTypologyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports